import {SxProps, Theme} from '@mui/material/styles'

type TableTooltipStyles = {
  tooltip: SxProps<Theme>
  wrapper: SxProps<Theme>
  table: SxProps<Theme>
  title: SxProps<Theme>
  headerRow: SxProps<Theme>
  body: SxProps<Theme>
  bodyRow: SxProps<Theme>
  headerCell: (minWidthCh: number) => SxProps<Theme>
  bodyCell: (minWidthCh: number) => SxProps<Theme>
}

const baseHeaderCell: SxProps<Theme> = {
  textAlign: 'left',
  fontWeight: 'bold',
  padding: '4px 8px',
  whiteSpace: 'nowrap',
}

const baseBodyCell: SxProps<Theme> = {
  padding: '4px 8px',
  whiteSpace: 'nowrap',
}

const styles: TableTooltipStyles = {
  tooltip: {
    maxWidth: 900,
    padding: 2,
    overflowX: 'auto',
  },
  wrapper: {
    display: 'inline-flex',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontFamily: 'monospace',
    fontSize: '0.8rem',
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 1,
  },
  headerRow: {},
  body: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
  bodyRow: {},
  headerCell: (minWidthCh: number) => ({
    ...baseHeaderCell,
    minWidth: minWidthCh ? `${minWidthCh}ch` : undefined,
  }),
  bodyCell: (minWidthCh: number) => ({
    ...baseBodyCell,
    minWidth: minWidthCh ? `${minWidthCh}ch` : undefined,
  }),
}

export default styles
